















import { BTab } from 'bootstrap-vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { navigateTo } from '@/common/RouteUtils';

@Component({ components: { BTab }, inheritAttrs: false })
export default class RouteTab extends Vue {
	@Prop({ type: String })
	public readonly route?: string;

	// Parent tabs match this route prefix regardless of their default entity params.
	@Prop({ type: String })
	public readonly activeRoute?: string;

	@Prop({ type: Object, default: () => ({}) })
	public readonly params!: Record<string, string>;

	public active = false;

	@Watch('isActive', { immediate: true })
	public activate(isActive: boolean): void {
		// Let b-tabs deactivate siblings. Setting active=false selects its first sibling.
		if (isActive) this.active = true;
	}

	@Watch('active')
	public async restoreActive(active: boolean): Promise<void> {
		if (active || !this.isActive) return;
		await this.$nextTick();
		// A delayed or rejected navigation must leave the current route's tab selected.
		if (this.isActive) this.active = true;
	}

	public get isActive(): boolean {
		const prefix = this.activeRoute || this.route;
		const name = this.$route?.name;
		return (
			!!prefix &&
			!!name &&
			(name === prefix || name.startsWith(`${prefix}.`)) &&
			(!!this.activeRoute ||
				Object.entries(this.params).every(
					([key, value]) => String(this.$route.params[key]) === value,
				))
		);
	}

	public async navigate(): Promise<void> {
		if (!this.route) {
			return;
		}

		// Pushing the current URL also cancels a pending navigation to another tab.
		await navigateTo(
			this.$router,
			this.isActive
				? this.$route.fullPath
				: { name: this.route, params: { ...this.$route.params, ...this.params } },
		);
	}
}
